import noImage from '../../img/nophotoproduct.jpg'

export const dummyCategory = {
    description: '<p>This is a category description element. Description for a category can be changed from Categories Page in the backoffice. Categories Page link is available from left menu.</p>',
    image: noImage,
    name: "Your category's title",
}